import get from 'lodash-es/get'

import * as styles from './Image.module.css'

function Image({ description, file, title }) {
  if (file) {
    const thumbnail = get(file, ['thumbnails', '340'])
    const src = thumbnail || file.preview

    if (src) {
      const alt = title || description

      return (
        <div className={styles.image}>
          <img alt={alt} src={src} />
        </div>
      )
    }
  }

  return null
}

export default Image
